import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.DESENTRANHAMENTO.CRIAR_TERMO](context, idDocumento) {
		const { data } = await api.desentranhamentoDocumentoPedido.criarTermoDesentranhamento(idDocumento)
		return data
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.DESENTRANHAMENTO.JUNTAR_TERMO](context, idDocumento) {
		const { data } = await api.desentranhamentoDocumentoPedido.juntarTermoDesentranhamento(idDocumento)
		return data
	},
}
